export default "__VITE_ASSET__4ce48cdb__"